import { createContext } from 'react'

const BlockChainContext = createContext(undefined)

export default BlockChainContext